/**
 * Экранирование — обязанность вызывающего: секции печати собирают HTML
 * строками, и любой текст, пришедший из анализа, обязан пройти здесь.
 */
export function escapeHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
